/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Checkbox from "@mui/material/Checkbox";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
// import uniLoginSVG from "assets/images/unilogin.svg";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-up-cover.jpeg";
import { useState } from "react";
import { Auth } from "aws-amplify";
import { useAppContext } from "context/app-context";
import Loader from "components/Loader";
import { createGeeksterUser } from "services/user-services";
import { FormControlLabel, FormGroup } from "@mui/material";
import { subscribeNewsLetter } from "services/sendpulse-service";

function Cover(): JSX.Element {
  const navigate = useNavigate()

  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [role, setRole] = useState<string>('TEACHER')
  const [checkedTAC, setCheckedTAC] = useState(false)
  const [subscribeNewsletter, setSubscribeNewsletter] = useState(false)
  const { handleMessage } = useAppContext()
  // const [authenticationWay, setAuthenticationWay] = useState('')


  const handleSignUp = async () => {
    setIsLoading(true)
    try {
      // if (authenticationWay === 'email') {
      await createGeeksterUser({ email, password, role, uniLoginUsername: undefined })
      const user = await Auth.signIn(email, password)
      if (subscribeNewsletter) {
        await subscribeNewsLetter(email)
      }
      setUser(user)
      navigate('/cards/generator')
      // } else {
      //   const { clientUri } = await getUniloginUri(`${window.location.origin}/authentication/complete?subscribeNewsLetter=${subscribeNewsLetter}`)
      //   window.location.href = clientUri
      // }
    } catch (error) {
      //@ts-ignore
      handleMessage(error?.response?.data?.message || error?.message, 'error')
      return
    } finally {
      setIsLoading(false)
    }
  }

  const { setUser } = useAppContext()
  const [isLoading, setIsLoading] = useState<boolean>(false)


  return (
    <CoverLayout image={bgImage}>
      {isLoading && <Loader />}
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-8}
          p={3}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Quiz med os allerede i dag
          </MDTypography>
          <MDTypography display="block" variant="button" color="white" my={1}>
            Skriv din email og kodeord for at oprette
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          {/* <div style={{ textAlign: 'center' }}>
            <ButtonGroup variant="contained" aria-label="outlined primary button group">
              <MDButton onClick={() => setAuthenticationWay('email')} color={authenticationWay === 'email' ? "secondary" : 'light'}>E-mail</MDButton>
              <MDButton onClick={() => setAuthenticationWay('unilogin')} color={authenticationWay === 'unilogin' ? "secondary" : 'light'}>
                <img
                  style={{ filter: 'drop-shadow(0 0 2px rgb(255 255 255 / 1))' }}
                  width={80} src={uniLoginSVG} alt="unilogin" /></MDButton>
            </ButtonGroup>
          </div> */}
          <MDBox component="form" role="form">
            {/* {authenticationWay === 'email' && <> */}
            <MDBox mb={2}>
              <MDInput type="email" label="Email" value={email} onChange={(e: any) => setEmail(e.target.value)} variant="standard" fullWidth />
            </MDBox>
            <MDBox mb={2}>
              <MDInput type="password" value={password} onChange={(e: any) => setPassword(e.target.value)} label="Kodeord" variant="standard" fullWidth />
            </MDBox>
            {/* </>} */}
            {/* {authenticationWay && <> */}
            <MDBox display="flex" alignItems="center">
              <FormGroup>
                <FormControlLabel
                  sx={{
                    fontWeight: 300,
                  }}
                  control={<Checkbox
                    checked={checkedTAC}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setCheckedTAC(e.target.checked)} />
                  }
                  label={
                    <><MDTypography
                      variant="button"
                      fontWeight="regular"
                      color="text"
                      sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                    >
                      I er enig i&nbsp;
                    </MDTypography>
                      <MDTypography
                        component="a"
                        href="#"
                        variant="button"
                        fontWeight="bold"
                        color="info"
                        textGradient
                      >
                        handelsbetingelserne
                      </MDTypography>
                    </>} />
              </FormGroup>

            </MDBox>
            <MDBox display="flex" alignItems="center" >
              <FormGroup>
                <FormControlLabel
                  sx={{
                    fontWeight: 300,
                  }}
                  control={<Checkbox
                    checked={subscribeNewsletter}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSubscribeNewsletter(e.target.checked)} />}
                  label={
                    <MDTypography
                      variant="button"
                      fontWeight="regular"
                      color="text"
                      sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                    >Tilmeld dig Quizedu nyhedsbrev

                    </MDTypography>
                  } /></FormGroup>
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton disabled={!checkedTAC || isLoading} variant="gradient" color="info" fullWidth onClick={handleSignUp}>
                opret bruger
              </MDButton>
            </MDBox>
            {/* </>} */}
            <MDBox mt={3} mb={0} textAlign="center">
              <MDTypography variant="button" color="text">
                Ingen konto?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-up"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Opret dig
                </MDTypography>
              </MDTypography>
            </MDBox>
            <MDBox mt={0} mb={1} textAlign="center">
              <MDTypography variant="button" color="text">
                Har du adgang?{" "}
                <MDTypography
                  component={Link}
                  to="/authentication/sign-in"
                  variant="button"
                  color="info"
                  fontWeight="medium"
                  textGradient
                >
                  Login her
                </MDTypography>
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </CoverLayout >
  );
}

export default Cover;
